const axios = require('axios');

export default class CacheService {
  _cachedDataPromisesMapping = {};

  getCachedData(route) {
    const promise = this._cachedDataPromisesMapping[route];
    if (promise) {
      return promise;
    }
    
    const newPromise = axios.get(route).then(res => res.data);
    this._cachedDataPromisesMapping[route] = newPromise;
    return newPromise;
  }
}